import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  Exemption_5_3
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";

@Component({
    selector: 'app-visit-exemptions-exemption-5-3',
    templateUrl: './exemption_5_3.component.html',
    styleUrls: ['./exemption_5_3.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_5_3Component extends ExemptionBaseComponent {
  @Input() exemption: Exemption_5_3;
}

